export enum CalculationMethod {
    FLAT_RATE = 'flat_rate',
    PER_KM = 'per_km',
    PER_KG = 'per_kg',
    PER_ITEM = 'per_item',
    TIERED_DISTANCE = 'tiered_distance',
    TIERED_WEIGHT = 'tiered_weight',
    COMBINED = 'combined'
}

export interface DeliveryFeeTier {
    id: number;
    config_id: number;
    min_value: number;
    max_value: number | null;
    fee: number;
    created_at: string;
}

export interface DeliveryFeeConfig {
    id: number;
    name: string;
    description: string | null;
    calculation_method: CalculationMethod;
    is_active: boolean;
    is_default: boolean;
    base_fee: number;
    free_delivery_threshold: number | null;
    price_per_km: number | null;
    min_distance_km: number | null;
    max_distance_km: number | null;
    price_per_kg: number | null;
    min_weight_kg: number | null;
    max_weight_kg: number | null;
    price_per_item: number | null;
    max_delivery_fee: number | null;
    applicable_regions: string | null;
    origin_address: string | null;
    origin_city: string | null;
    origin_postal_code: string | null;
    origin_country: string | null;
    origin_maps_link: string | null;
    priority: number;
    created_by: number;
    created_at: string;
    updated_at: string;
}

export interface DeliveryFeeConfigWithTiers extends DeliveryFeeConfig {
    tiers: DeliveryFeeTier[];
}

export interface DeliveryFeeConfigCreate {
    name: string;
    description?: string;
    calculation_method: CalculationMethod;
    is_active: boolean;
    is_default: boolean;
    base_fee: number;
    free_delivery_threshold?: number;
    price_per_km?: number;
    min_distance_km?: number;
    max_distance_km?: number;
    price_per_kg?: number;
    min_weight_kg?: number;
    max_weight_kg?: number;
    price_per_item?: number;
    max_delivery_fee?: number;
    applicable_regions?: string;
    origin_address?: string;
    origin_city?: string;
    origin_postal_code?: string;
    origin_country?: string;
    origin_maps_link?: string;
    priority: number;
}

export interface DeliveryFeeTierCreate {
    min_value: number;
    max_value?: number;
    fee: number;
}

export interface DeliveryFeeCalculationRequest {
    distance_km?: number;
    total_weight_kg?: number;
    total_quantity?: number;
    order_subtotal?: number;
    config_id?: number;
}

export interface DeliveryFeeCalculationResponse {
    delivery_fee: number;
    calculation_method: string;
    config_name: string;
    breakdown: Record<string, any>;
    is_free_delivery: boolean;
}

export const CALCULATION_METHOD_LABELS: Record<CalculationMethod, string> = {
    [CalculationMethod.FLAT_RATE]: 'Forfait fixe',
    [CalculationMethod.PER_KM]: 'Par kilomètre',
    [CalculationMethod.PER_KG]: 'Par kilogramme',
    [CalculationMethod.PER_ITEM]: 'Par article',
    [CalculationMethod.TIERED_DISTANCE]: 'Paliers de distance',
    [CalculationMethod.TIERED_WEIGHT]: 'Paliers de poids',
    [CalculationMethod.COMBINED]: 'Combiné'
};
